import { render, staticRenderFns } from "./form-input-formatted.vue?vue&type=template&id=830cec9a"
import script from "./form-input-formatted.vue?vue&type=script&lang=js"
export * from "./form-input-formatted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports